<template>
  <v-row />
</template>
<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
import firebase from '@/api/firebase'
import 'firebase/firestore/memory'

export default {
  name: 'MyLists',
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    xp: {
      type: Object,
      default: () => {}
    }
  },
  data (){
    return {
      toastOptions: {
        position: 'bottom-center',
        duration: 3000,
      },
    }
  },
  methods: {
    updateList(index, listName){
      let xpOnList = false
      for(let i = 0; i < this.user.lists[index].experiences.length; i++){
        if (this.user.lists[index].experiences[i] == this.xp.id){
          xpOnList = true
        }
      }
      if (xpOnList) this.addToUserList(listName)
      else this.deleteFromUserList(listName)
    },
    addToUserList(listName) {
    // Add the "type" field to the 3D experiences, given that
    // they are not registered in Firestore in the same way 360 and Labs are.
    let index = this.findIndexByListName(listName)
      let params = {
        'id': this.user.uid,
        'listName': listName,
        'experienceId': this.xp.id
      }
      if (!this.xp.type) {
        this.xp.type = '3d'
      }
      this.user.lists[index].experiences.push(this.xp.id)

      firebase.addExperienceToUserList(params)
      let text = `Salvo em "${params.listName}"`
      this.$toasted.clear()
      this.$toasted.show(text, {
        position: 'bottom-center',
        duration: 5000,
        action : {
          text: 'Ver',
          onClick : (e, toastObject) => {
            if (this.$router.currentRoute.name !== 'ContentMyLists')
              this.$router.push({ name: 'ContentMyLists' })
            toastObject.goAway(0)
          },
        }
      })
    },
    deleteFromUserList(listName) {
      let index = this.findIndexByListName(listName)
      let params = {
        'id': this.user.uid,
        'listName': listName,
        'experienceId': this.xp.id
      }
      let course = this.user.lists[index]
      for (let i = 0; i < course.experiences.length; i++) {
        let experience = course.experiences[i]
        if(experience == this.xp.id || experience.id == this.xp.id) {
          this.user.lists[index].experiences.splice(i, 1)
        }
      }
      firebase.deleteExperienceFromUserList(params)
      let text = `Removido de "${params.listName}"`
      this.$toasted.clear()
      this.$toasted.show(text, this.toastOptions)
    },
    createUserList(listName) {
      let experiences = []
      let params = {
        'id': this.user.uid,
        'listName': listName
      }
      let listProp = {
        'name': params.listName,
        'experiences': experiences
      }
      if(params.listName){
        let course = {}
        if (!this.user.lists) {
          course = [listProp]
          this.user.lists = (course)
        } else {
          course = listProp
          this.user.lists.push(course)
          this.user.lists.sort((a, b) => (a.name > b.name) ? 1 : -1)
        }
        firebase.createUserList(params)
      }
    },
    findIndexByListName(listName){
      for (let i=0; i < this.user.lists.length; i++){
        if(this.user.lists[i].name == listName){
          return i
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
